import React, { useState, useEffect } from 'react';
import { Paper, Grid, Card, CardContent, Typography } from '@mui/material';
import axiosInstance from '../utills/axiosInstance';

const PayrollDashboard = () => {
  const [stats, setStats] = useState({});

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const res = await axiosInstance.get('/api/payroll/dashboard');
      setStats(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>Payroll Dashboard</Typography>

      <Grid container spacing={3}>
        <Grid item xs={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary">Active Employees</Typography>
              <Typography variant="h5">{stats.employees || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary">Pay Runs Completed</Typography>
              <Typography variant="h5">{stats.payRuns || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary">Slips Generated</Typography>
              <Typography variant="h5">{stats.slips || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary">Pending Approvals</Typography>
              <Typography variant="h5">0</Typography>
            </CardContent>
          </Card>
        </Grid>
        {/* Statutory Stats */}
        <Grid item xs={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary">EPF Employee</Typography>
              <Typography variant="h5">₹{stats.epfEmployee || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary">EPF Employer</Typography>
              <Typography variant="h5">₹{stats.epfEmployer || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary">ESIC Employee</Typography>
              <Typography variant="h5">₹{stats.esicEmployee || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary">PT</Typography>
              <Typography variant="h5">₹{stats.pt || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary">TDS</Typography>
              <Typography variant="h5">₹{stats.tds || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PayrollDashboard;
